export const SET_POPUP_STATUS = 'SET_POPUP_STATUS';